import {
  genericGetSingle,
  genericGetAll,
  genericUpdateSingle,
  genericDeleteSingle,
} from "../helpers/apiCall";
import { Error } from "../types";
import { iLine } from "../models";
import { parseJSONData } from "../helpers/json";

/**
 * Get all iLines
 * @param params URLSearchParams
 * @returns Promise<{ lines: iLine[] }>
 */
function getAll(params: URLSearchParams = null): Promise<{ lines: iLine[] }> {
  return genericGetAll("i_lines", params).then((response) => {
    if (response?.lines) {
      response.lines.forEach((line) => {
        line.loadedData = parseJSONData(line?.data);
      });
    }
    return response;
  });
}

/**
 * Get a single iLine
 * @param id number | string
 * @returns Promise<{ line: iLine }>
 */
function getSingle(id: number | string): Promise<{ line: iLine }> {
  return genericGetSingle("i_lines", id).then((response) => {
    if (response?.line?.data) {
      response.line.loadedData = parseJSONData(response.line.data);
    }
    return response;
  });
}

/**
 * Get a single iLine
 * @param id number | string
 * @param line { [key: string]: string | number | boolean | Date | undefined}
 * @returns Promise<{ line: iLine } | Error>
 */
function updateSingle(
  id: number | string,
  line: { [key: string]: string | number | boolean | Date | undefined },
): Promise<{ line: iLine } | Error> {
  return genericUpdateSingle("i_lines", id, line).then((response) => {
    if (response?.line?.data) {
      response.line.loadedData = parseJSONData(response.line.data);
    }
    return response;
  });
}

/**
 * Delete a single iLine
 * @param id number | string
 * @returns Promise<{ deleted: boolean } | { error: string }>
 */
function deleteSingle(
  id: number | string,
): Promise<{ deleted: boolean } | { error: string }> {
  return genericDeleteSingle("i_lines", id);
}

/**
 * Gets the count of iLines
 * @param params URLSearchParams
 * @returns Promise<{ count: number }>
 */
function getCount(params: URLSearchParams = null): Promise<{ count: number }> {
  params.append("countOnly", "true");
  return genericGetAll("i_lines", params);
}

export const iLineService = {
  getAll,
  getSingle,
  updateSingle,
  deleteSingle,
  getCount,
};
